"use strict";
/**
 * Size Quick-Add on Product Cards
 *
 * Adds AJAX add-to-cart behaviour to the size variant buttons
 * rendered by the product-grid-item snippet when the
 * "Enable size quick-add on cards" theme setting is active.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var SELECTORS = {
    container: "[data-size-quick-add]",
    button: ".size-quick-add__btn",
};
var CLASSES = {
    loading: "size-quick-add__btn--loading",
    added: "size-quick-add__btn--added",
    error: "size-quick-add__btn--error",
};
function bindContainer(container) {
    // Avoid double-binding after section re-renders
    if (container.dataset.sizeQuickAddBound === "true")
        return;
    container.dataset.sizeQuickAddBound = "true";
    container.addEventListener("click", function (evt) {
        var _a, _b;
        var target = evt.target;
        var btn = target.closest(SELECTORS.button);
        if (!btn)
            return;
        evt.preventDefault();
        evt.stopPropagation();
        if (btn.classList.contains(CLASSES.loading) ||
            btn.classList.contains(CLASSES.added)) {
            return;
        }
        var variantId = btn.dataset.variantId;
        if (!variantId)
            return;
        var originalText = (_b = (_a = btn.textContent) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : "";
        btn.classList.add(CLASSES.loading);
        fetch(theme.routes.cartAdd, {
            method: "POST",
            body: "id=" + variantId + "&quantity=1",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-Requested-With": "XMLHttpRequest",
            },
        })
            .then(function (res) { return res.json(); })
            .then(function (data) {
            btn.classList.remove(CLASSES.loading);
            if (data.status === 422) {
                btn.classList.add(CLASSES.error);
                btn.textContent = theme.strings.soldOut || "Sold out";
                setTimeout(function () {
                    btn.classList.remove(CLASSES.error);
                    btn.textContent = originalText;
                }, 2000);
                return;
            }
            // Success
            btn.classList.add(CLASSES.added);
            btn.textContent = theme.strings.addedToCart || "Added!";
            document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
                detail: { product: data, addToCartBtn: btn },
            }));
            setTimeout(function () {
                btn.classList.remove(CLASSES.added);
                btn.textContent = originalText;
            }, 1500);
        })
            .catch(function () {
            btn.classList.remove(CLASSES.loading);
        });
    });
}
function sizeQuickAddInit() {
    var containers = document.querySelectorAll(SELECTORS.container);
    containers.forEach(bindContainer);
}
exports.default = sizeQuickAddInit;
